import React, { forwardRef } from "react"
import styles from "./page-wrapper-content.module.css"
import { cn } from "@/utils/styles.ts"

interface PageContentWrapperSmallProps {
  children: React.ReactNode
  hasPadding?: boolean
  className?: string
  isLoading?: boolean
}

const PageContentWrapperAI = forwardRef<
  HTMLDivElement,
  PageContentWrapperSmallProps
>(({ children, hasPadding = true, className, isLoading }, ref) => {
  return (
    <div
      ref={ref}
      className={cn(styles.scrollableContentAI, className)}
      style={{
        padding: hasPadding ? "16px" : 0,
        ...(isLoading
          ? { backgroundImage: 'url("/public/logo-grey-loading.svg")' }
          : {}),
      }}
    >
      {children}
    </div>
  )
})

export default PageContentWrapperAI
